import React from 'react';
import LineChart, { LineChartProps } from '@components/report/chart/line-chart/LineChart';
import VerticalBarAverageChart, {
	VerticalBarAverageChartProps,
} from '@components/report/chart/vertical-bar-average-chart/VerticalBarAverageChart';
import ReportCard from '@components/report/report-card/ReportCard';
import { threeDivisionGridClass } from '@components/report/style.css';

export interface VisitorsAndViewsProps {
	visitors?: LineChartProps;
	averageViews?: VerticalBarAverageChartProps;

	isLoading?: boolean;
	isError?: boolean;
	lackOfPermission?: boolean;
}

const VisitorsAndViews = ({
	visitors,
	averageViews,

	isLoading,
	isError,
	lackOfPermission,
}: VisitorsAndViewsProps) => {
	const status = { isLoading, isError, lackOfPermission };
	return (
		<div className={threeDivisionGridClass}>
			<ReportCard
				label="방문자 수"
				tooltip="최초 데이터 수집일과 비교하여 현재까지의 팔로워 증가 수를 나타냅니다. 계정의 팔로워 수가 시간에 따라 어떻게 변화했는지 확인할 수 있습니다."
				lackOfPermission={lackOfPermission}
			>
				<LineChart
					subDesc="최근 30일 기준"
					data_name_a="누적 방문자 수"
					desc
					{...status}
					{...visitors}
				/>
			</ReportCard>

			<ReportCard
				label="게시글 일 평균 조회 수"
				tooltip="최근 10개의 콘텐츠를 기준으로 계산된 게시글 일 평균 조회 수입니다."
				lackOfPermission={lackOfPermission}
			>
				<VerticalBarAverageChart
					subDesc="최근 게시글 10개 기준"
					valueUnit="회"
					label="평균 조회 수"
					desc
					{...averageViews}
					{...status}
				/>
			</ReportCard>
		</div>
	);
};

export default VisitorsAndViews;
